// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-content-2[data-v-ff6761fe]{position:relative;top:-40px}.card[data-v-ff6761fe]{margin:14px 18px;cursor:pointer}.card[data-v-ff6761fe]:hover{-webkit-transform:scale(1.1);transform:scale(1.1)}", ""]);
// Exports
module.exports = exports;
